module.exports = __webpack_public_path__ + "img/logo-ios.84551d8b.png";